<!-- 项目文件 -->
<template>
    <div class="w100p">
        <Header></Header>
        <Titleimg :img="bgImg"></Titleimg>
        <div class="pt25 pl16 pr16 pb25 bgfff">
            <p class="fs16 c333 disinblock posre textc w100p flexc">
                <span class="border-bottom1">
                    驾校招生小程序
                </span>
            </p>
            <div class="pt26 pb16 textc">
                <span class="c1076 fs20 disinblock fbold pr4">多样活动模板</span>
                <span class="c43d fs20  disinblock fbold pl4">玩转招生营销</span>
            </div>
            <div>
                <van-image lazy-load class="imgauto" :src="img46" />
            </div>
        </div>

        <div class="mt16 pt40 pl16 pr16 pb24 bg53">
            <P class="c1076 fs20 fbold">智能营销获客系统</P>
            <P class="c43d fs13 fbold pt8">智能营销获客系统</P>
            <div class="fs12 c999 pt16 pb16 lh18">
                【驾校招生助手】是基于微信和AI技术开发的智能平台，彻底打通 企业管理者、销售与客户之间的关系，帮助企业对销售人员进行管理，优化销售成本，增加收入。
            </div>
            <div>
                <van-row type="flex" justify="space-between"  class="pb4">
                    <van-col span="8"  >
                        <div class="icon-img textc">
                            <img class="w70 h70" src="../../../public/img/img47.png" alt="">
                        </div>
                        <div class="icon-text textc">
                            <p class="fs14 c1076 fbold">流量追踪</p>
                        
                            <div class="pt5">
                                <P class="fs11 c999  ">提升员工专业形象</P>
                                <p class="fs11 c999  ">打造专属私域流量池</p>
                            </div>
                        </div>
                    </van-col>
                    <van-col span="8">
                        <div class="icon-img textc">
                            <img class="w70 h70" src="../../../public/img/img48.png" alt="">
                        </div>
                        <div class="icon-text textc">
                            <p class="fs14 c1076 fbold">用户锁定</p>
                    
                            <div class="pt5">
                                <P class="fs11 c999  ">快速锁定客户</P>
                                <p class="fs11 c999  ">了解需求不错漏</p>
                            </div>
                        </div>
                    </van-col>
                    <van-col span="8">
                        <div class="icon-img textc">
                            <img class="w70 h70" src="../../../public/img/img49.png" alt="">
                        </div>
                        <div class="icon-text textc">
                            <p class="fs14 c1076 fbold">全员招生</p>
                            <div class="pt5">
                                <P class="fs11 c999  ">每个员工都</P>
                                <p class="fs11 c999  ">可为驾校扩展生源</p>
                            </div>
                        </div>
                    </van-col>
                </van-row>

                <van-row type="flex" justify="space-between"  class="pt4">
                    <van-col span="8">
                        <div class="icon-img textc">
                            <img class="w70 h70" src="../../../public/img/img50.png" alt="">
                        </div>
                        <div class="icon-text textc">
                            <p class="fs14 c1076 fbold">二级分销</p>
                            <div class="pt5">
                                <P class="fs11 c999  ">人人都做</P>
                                <p class="fs11 c999  ">你的分销商</p>
                            </div>
                        </div>
                    </van-col>
                    <van-col span="8">
                        <div class="icon-img textc">
                            <img class="w70 h70" src="../../../public/img/img51.png" alt="">
                        </div>
                        <div class="icon-text textc">
                            <p class="fs14 c1076 fbold">爆炸式招生模板</p>
                            <div class="pt5">
                                <P class="fs11 c999  ">个性定制让学员</P>
                                <p class="fs11 c999  ">抢着报名的招生方案</p>
                            </div>
                        </div>
                    </van-col>
                    <van-col span="8">
                        <div class="icon-img textc">
                            <img class="w70 h70" src="../../../public/img/img52.png" alt="">
                        </div>
                        <div class="icon-text textc">
                            <p class="fs14 c1076 fbold">多种节日热点海报</p>
                            <div class="pt5">
                                <P class="fs11 c999  ">个性定制</P>
                                <p class="fs11 c999  ">一键分发海量曝光</p>
                            </div>
                        </div>
                    </van-col>
                </van-row>
            </div>
        </div>

        <div class="pl16 pr16 bgfff pt24 pb24">
            <div class="alit flexc textc pb16">
                <span class="bordercc w40 disinblock mr10"></span>
                <span class="c1076 fs20 disinblock fbold pr4">一套招生程序</span>
                <span class="c43d fs20  disinblock fbold pl4">七大系统加持</span>
                <span class="bordercc w40 disinblock ml10"></span>
            </div>
            <div>
                <van-grid :column-num="2" :border="false" >
                    <van-grid-item >
                        <div class="">
                            <img class="imgauto" src="../../../public/img/img54.png" alt="">
                        </div>
                    </van-grid-item>

                    <van-grid-item class="">
                        <div class="textl bg1072 bradius2 h100p  pl12 pr12 pt10 pb10 lh18">
                            <p class="posre overflow">
                                <span class="fs15 cfff disinblock">智能海报</span>
                                <span class="disinblock cfff fs20 fbold opacity5 floatr">
                                    01
                                </span>
                            </p>
                            <p class="fs13 cfff pt8 pb8">一键转发 快速裂变</p>
                            <P class="fs12 cfff">基于微信小程序的企业、个人专属海报，一键转发，即可实现流量裂变。支持文字、语音、图片等丰富展示形式，更加立体展示企业/个人形象。</P>
                        </div>
                    </van-grid-item>

                    <van-grid-item class="">
                        <div class="textl bgfbb5  bradius2 h100p  pl12 pr12 pt10 pb10 lh18">
                            <p class="posre overflow">
                                <span class="fs15 cfff disinblock">企业商城</span>
                                <span class="disinblock cfff fs20 fbold opacity5 floatr">
                                    02
                                </span>
                            </p>
                            <p class="fs13 cfff pt8 pb8">全员营销 在线交易</p>
                            <P class="fs12 cfff">海报/名片小程序自带商城，一键转发微信好友、朋友圈即可触达客户流量。通过招募分销的形式，分享海报/名片成交之后便可获取佣金，真正快速实现社会化营销。</P>
                        </div>
                    </van-grid-item>

                    <van-grid-item class="">
                        <div class="textl bg1072  bradius2 h100p pl12 pr12 pt10 pb10 lh18">
                            <p class="posre overflow">
                                <span class="fs15 cfff disinblock">小程序官网</span>
                                <span class="disinblock cfff fs20 fbold opacity5 floatr">
                                    03
                                </span>
                            </p>
                            <p class="fs13 cfff pt8 pb8">企业形象 统一展示</p>
                            <P class="fs12 cfff">企业信息、活动等内容实时发布，客户快速了解企业实力和信誉背景，增强信任感。</P>
                        </div>
                    </van-grid-item>

                    <van-grid-item class="">
                        <div class="textl bg1072  bradius2 h100p pl12 pr12 pt10 pb10 lh18">
                            <p class="posre overflow">
                                <span class="fs15 cfff disinblock">二级分销</span>
                                <span class="disinblock cfff fs20 fbold opacity5 floatr">
                                    04
                                </span>
                            </p>
                            <p class="fs13 cfff pt8 pb8">实现招生 营销裂变</p>
                            <P class="fs12 cfff">设置驾校分销体系，打造自己的营销帝国。全员招生，每个员工都可为驾校扩展生源，人人都做分销商，降低招生成本，招生提升50%。</P>
                        </div>
                    </van-grid-item>

                    <van-grid-item class="">
                        <div class="textl bg1072  bradius2 h100p pl12 pr12 pt10 pb10 lh18">
                            <p class="posre overflow">
                                <span class="fs15 cfff disinblock">智慧客服</span>
                                <span class="disinblock cfff fs20 fbold opacity5 floatr">
                                    05
                                </span>
                            </p>
                            <p class="fs13 cfff pt8 pb8">超强话术 高效沟通</p>
                            <P class="fs12 cfff">企业可建立自己的话术库，让销售员沟通更加有效；客户访问名片自动生成接待列表，聊天信息分类管理，方便销售及时跟进。</P>
                        </div>
                    </van-grid-item>

                    <van-grid-item class="">
                        <div class="textl bg1072  bradius2 h100p pl12 pr12 pt10 pb10 lh18">
                            <p class="posre overflow">
                                <span class="fs15 cfff disinblock">Boss望远镜</span>
                                <span class="disinblock cfff fs20 fbold opacity5 floatr">
                                    06
                                </span>
                            </p>
                            <p class="fs13 cfff pt8 pb8">智能管理 深度管控</p>
                            <P class="fs12 cfff">系统测评员工综合能力，识别有价值员工；实时查看客户情况与销售排名，全面掌握销售进程；一键交接离职员工，保护企业资产不流失。</P>
                        </div>
                    </van-grid-item>

                    <van-grid-item class="">
                        <div class="textl bg1072  bradius2 h100p pl12 pr12 pt10 pb10 lh18">
                            <p class="posre overflow">
                                <span class="fs15 cfff disinblock">销售狙击眼</span>
                                <span class="disinblock cfff fs20 fbold opacity5 floatr">
                                    07
                                </span>
                            </p>
                            <p class="fs13 cfff pt8 pb8">客户追踪 实时跟进</p>
                            <P class="fs12 cfff">智能获取客户浏览轨迹，通过行为喜好、互动倾向等分析，构建智能客户画像、并实现标签化管理，保证销售实现精准营销。</P>
                        </div>
                    </van-grid-item>

                
                </van-grid>
            </div>
        </div>

        <div class="w100p bgfcf8 pb50">
            <van-image lazy-load class="imgauto" :src="img55" />
        </div>
        <Applyset></Applyset>
        <Footer></Footer>

    </div>
</template>

<script>
    import Header from '@/components/Header';
    import Footer from '@/components/Footer';
    import Titleimg from '@/components/Titleimg';
    import Applyset from '@/components/Applyset';
    import $ from "jquery";
    export default {
        data() {
            return {
                bgImg: require('../../../public/img/img45.png'),
                img46: require('../../../public/img/img46.png'),
                img55: require('../../../public/img/img55.png'),

            };
        },
        components: {
            Header,
            Titleimg,
            Footer,
            Applyset
        },
        methods: {

        },
        created() {

        },
        mounted() {

        },
    }
</script>
<style scoped>
    .bg53 {
        background-image: url('../../../public/img/img53.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }
    
    /deep/.van-grid-item .van-grid-item__content {
        padding: 8px 8px;
    }
</style>